import { render } from "./addEditBaseDepartment.vue?vue&type=template&id=13ad2d46"
import script from "./addEditBaseDepartment.vue?vue&type=script&lang=js"
export * from "./addEditBaseDepartment.vue?vue&type=script&lang=js"

import exportComponent from "E:\\源码\\baoxiu\\baoxiu\\VUE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__